import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Routes visible to `role="cleaner"` users. Everything else redirects to /cleaning.
// Session Z85 — cleaners see Dashboard + Calendar + Cleaning + Properties
// (Properties is read-only; backend blocks writes).
const CLEANER_ALLOWED_ROUTES = ["/", "/calendar", "/cleaning", "/properties", "/training-guides", "/damage-reports"];

function isCleanerAllowed(pathname) {
  if (pathname === "/") return true;
  return CLEANER_ALLOWED_ROUTES.some(
    (p) => p !== "/" && (pathname === p || pathname.startsWith(p + "/"))
  );
}

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="flex items-center justify-center h-screen text-slate-500 font-serif tracking-wide">
        Loading Newport Stays…
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  if (user.role === "cleaner" && !isCleanerAllowed(location.pathname)) {
    return <Navigate to="/cleaning" replace />;
  }
  return children;
}
